import { useState } from "react"

type ModalType = string

export function useModal() {
  const [isOpen, setIsOpen] = useState<Record<ModalType, boolean>>({
    add: false,
    edit: false,
    delete: false,
    detail: false,
  })

  const open = (type: ModalType) => {
    setIsOpen((prev) => ({ ...prev, [type]: true }))
  }

  const close = (type: ModalType) => {
    setIsOpen((prev) => ({ ...prev, [type]: false }))
  }

  const toggle = (type: ModalType) => {
    setIsOpen((prev) => ({ ...prev, [type]: !prev[type] }))
  }

  return {
    isOpen,
    open,
    close,
    toggle,
  }
}
